import { containerDpBannerAdsContenMainSX } from '@/components/blocks/DpLibrary/DpBannerAdsText/styles/container';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

export const DpBannerAdsText = ({
	image,
	title,
	subtitle,
	text,
	loading,
	priority,
}: {
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	title?: string;
	subtitle?: string;
	text?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;

	return (
		<Grid container sx={containerDpBannerAdsContenMainSX}>
			<Grid item xs={12} md={8}>
				<Img src={getImage} loading={loading} priority={priority} />
			</Grid>
			<Grid
				item
				xs={12}
				md={4}
				display={'flex'}
				flexDirection={'column'}
				justifyContent={'center'}
				sx={{ px: '37px' }}
			>
				<Typography
					component={'h2'}
					sx={{
						fontSize: 'var(--font-size-xl)',
						fontWeight: '800',
						color: 'text.primary',
						mb: '20px',
					}}
				>
					{title}
				</Typography>
				<Typography
					sx={{
						fontSize: 'var(--font-size-body)',
						fontWeight: 'normal',
						color: 'text.primary',
						mb: '20px',
					}}
				>
					{subtitle}
				</Typography>
				<Typography
					sx={{ fontSize: 'var(--font-size-body)', fontWeight: 'normal', color: 'text.primary' }}
				>
					{text}
				</Typography>
			</Grid>
		</Grid>
	);
};
